import { __read, __assign } from '../../../external/tslib/tslib.es6.mjs.js';
import { jsx } from 'react/jsx-runtime';
import { useState, useCallback, useEffect } from 'react';
import { useScrollbarWidth } from '../useScrollbarWidth/useScrollbarWidth.js';
import { ModalContext } from './ModalContext.js';

var ModalContextController = function (_a) {
    var children = _a.children;
    var _b = __read(useState(0), 2), count = _b[0], setCount = _b[1];
    var scrollbarWidth = useScrollbarWidth();
    var add = useCallback(function () {
        setCount(function (c) { return c + 1; });
    }, []);
    var subtract = useCallback(function () {
        setCount(function (c) { return c - 1; });
    }, []);
    // Block body scrolling and add marginRight/paddingRight to prevent page jumping right/left
    useEffect(function () {
        if (count > 0) {
            var scrollbarWidthPx_1 = "".concat(scrollbarWidth, "px");
            document.body.classList.add('has-modal-opened');
            document.body.style.marginRight = scrollbarWidthPx_1;
            // @TODO how to pass it in shared library
            document.querySelectorAll(".layout").forEach(function (el) {
                // eslint-disable-next-line no-param-reassign
                el.childNodes[0].style.paddingRight = scrollbarWidthPx_1;
            });
        }
        else {
            document.body.classList.remove('has-modal-opened');
            document.body.style.marginRight = '';
            // @TODO how to pass it in shared library
            document.querySelectorAll(".layout").forEach(function (el) {
                // eslint-disable-next-line no-param-reassign
                el.childNodes[0].style.paddingRight = '';
            });
        }
    }, [count, scrollbarWidth]);
    return jsx(ModalContext.Provider, __assign({ value: { count: count, add: add, subtract: subtract } }, { children: children }));
};

export { ModalContextController };
